module.exports = __webpack_public_path__ + "homepage6.png?a0d6195a092b41d209326fb6d8c768fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage6.png
// module id = 41
// module chunks = 0